<div class="administration-page">
  <div class="administration-header">
    <h1>Administration</h1>
  </div>

  @if (error()) {
    <div class="state-message error">{{ error() }}</div>
  }

  <div class="admin-section">
    <div class="section-header">
      <h2>Create organization</h2>
    </div>

    <div class="organization-form">
      <input
        type="text"
        placeholder="Organization name"
        [ngModel]="organizationName()"
        (ngModelChange)="organizationName.set($event)"
      />

      <input
        type="text"
        placeholder="Description"
        [ngModel]="organizationDescription()"
        (ngModelChange)="organizationDescription.set($event)"
      />

      <button class="primary-btn" type="button" [disabled]="saving()" (click)="createOrganization()">
        Create
      </button>
    </div>
  </div>

  <div class="admin-section">
    <div class="section-header">
      <h2>Organizations</h2>
      <button class="secondary-btn" type="button" (click)="loadOrganizations()" [disabled]="loading()">
        Refresh
      </button>
    </div>

    @if (loading()) {
      <div class="state-message">Loading organizations...</div>
    }

    @if (!loading()) {
      <div class="table-wrapper">
        <table class="admin-table">
          <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Users</th>
            <th>Actions</th>
          </tr>
          </thead>

          <tbody>
            @if (organizations().length) {
              @for (organization of organizations(); track organization.id) {
                <tr>
                  <td>
                    @if (editingOrganizationId() === organization.id) {
                      <input
                        class="table-input"
                        type="text"
                        [ngModel]="editingName()"
                        (ngModelChange)="editingName.set($event)"
                      />
                    } @else {
                      {{ organization.name }}
                    }
                  </td>
                  <td>
                    @if (editingOrganizationId() === organization.id) {
                      <input
                        class="table-input"
                        type="text"
                        [ngModel]="editingDescription()"
                        (ngModelChange)="editingDescription.set($event)"
                      />
                    } @else {
                      {{ organization.description || '-' }}
                    }
                  </td>
                  <td>{{ organization.users.length }}</td>
                  <td>
                    <div class="row-actions">
                      @if (editingOrganizationId() === organization.id) {
                        <button class="primary-btn small" type="button" [disabled]="saving()" (click)="saveEdit(organization)">
                          Save
                        </button>
                        <button class="secondary-btn small" type="button" [disabled]="saving()" (click)="cancelEdit()">
                          Cancel
                        </button>
                      } @else {
                        <button class="secondary-btn small" type="button" (click)="startEdit(organization)">
                          Edit
                        </button>
                        <button class="secondary-btn small" type="button" (click)="openUsersModal(organization)">
                          Users
                        </button>
                        <button class="danger-btn small" type="button" [disabled]="saving()" (click)="deleteOrganization(organization)">
                          Delete
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            } @else {
              <tr>
                <td colspan="4" class="empty-row">No organizations found.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

@if (deleteModalOpen() && organizationToDelete(); as organization) {
  <div class="modal-backdrop" (click)="closeDeleteModal()">
    <div class="confirm-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>Delete organization</h2>
      </div>

      <div class="confirm-modal-body">
        <p>
          Are you sure you want to delete
          <strong>{{ organization.name }}</strong>?
        </p>
        <p class="modal-warning">
          This will also remove the organization's users and alert assignments.
        </p>
      </div>

      <div class="modal-actions">
        <button class="secondary-btn" type="button" [disabled]="saving()" (click)="closeDeleteModal()">
          Cancel
        </button>
        <button class="danger-btn" type="button" [disabled]="saving()" (click)="confirmDeleteOrganization()">
          Delete
        </button>
      </div>
    </div>
  </div>
}

@if (usersModalOpen() && selectedOrganization(); as organization) {
  <div class="modal-backdrop" (click)="closeUsersModal()">
    <div class="users-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>{{ organization.name }} users</h2>
      </div>

      <div class="modal-body">
        @if (usersLoading()) {
          <div class="state-message">Loading users...</div>
        }

        <div class="users-section">
          <h3>Current users</h3>

          @if (assignedUsers().length) {
            <div class="user-list">
              @for (user of assignedUsers(); track user.id) {
                <div class="user-row">
                  <span>{{ getUserLabel(user) }}</span>
                  <button class="danger-btn small" type="button" [disabled]="saving()" (click)="removeUser(user)">
                    Remove
                  </button>
                </div>
              }
            </div>
          } @else {
            <p class="empty-text">No users assigned.</p>
          }
        </div>

        <div class="users-section">
          <h3>Available users</h3>

          @if (availableUsers().length) {
            <div class="user-list">
              @for (user of availableUsers(); track user.id) {
                <label class="user-row selectable">
                  <input
                    type="checkbox"
                    [checked]="isUserSelected(user.id)"
                    (change)="toggleUserSelection(user.id, $event)"
                  />
                  <span>{{ getUserLabel(user) }}</span>
                </label>
              }
            </div>
          } @else {
            <p class="empty-text">No available users.</p>
          }
        </div>
      </div>

      <div class="modal-actions">
        <button class="secondary-btn" type="button" [disabled]="saving()" (click)="closeUsersModal()">
          Close
        </button>
        <button class="primary-btn" type="button" [disabled]="saving() || !selectedUserIds().length" (click)="addSelectedUsers()">
          Add selected
        </button>
      </div>
    </div>
  </div>
}
